/* 
This service is for managing async requests for List items, so we can persist data and prevent over-fetching
List items can't store internal state, so we have to store promise state externally

The promise data is cleared on each page load
*/
export default class ListItemPromiseService {
  // typically the keys to this map will be a data reference, since item data persists for is lifecycle
  private promises: Map<unknown, Promise<unknown>> = new Map();

  add(ref: unknown, promise: Promise<unknown>) {
    // ideally we'd use WeakRef to prevent potential memory leaks, but not all out browsers support that and we clear the promises on page load anyways

    this.promises.set(ref, promise);
  }

  get<T>(ref: unknown): Promise<T> | undefined {
    return this.promises.get(ref) as Promise<T> | undefined;
  }

  clear() {
    this.promises.clear();
  }
}
